import type { AccessRestriction, DataScope, Role } from '@nexops/shared';

/** User as returned by `GET /auth/me`, `POST /auth/login`, `POST /demo/switch`. */
export interface AuthUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: Role;
  organizationId: string;
  managerId: string | null;
  /** Effective permission keys (see `PERMISSIONS` in @nexops/shared). */
  permissions: string[];
  dataScope: DataScope;
  /** Set while the session may only change the password or set up 2FA (server-enforced). */
  restriction?: AccessRestriction;
}

/** Flagi funkcji z backendu (`GET /auth/me` → `features`). Domyślnie wszystkie wyłączone, dopóki backend nie zgłosi inaczej. */
export interface AppFeatures {
  /** AI Insight floty (backend: FLEET_AI_ENABLED). */
  fleetAi: boolean;
}

export const NO_FEATURES: AppFeatures = { fleetAi: false };

export interface LoginPayload {
  email: string;
  password: string;
  totp?: string;
}

export interface DemoUser {
  id: string;
  firstName: string;
  lastName: string;
  role: Role;
}
